import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { addDays, format } from 'date-fns';

import { useStore } from 'core/store/';
import { OfferPageTabs } from 'core/store/offer-store';
import { useToast } from 'core/components/toast';
import { Discount } from '../discount';

const FutureEffectiveAdvancedQuote = ({ ...discount }) => {
  const { offer: store } = useStore();
  const toast = useToast();

  const onAdd = useCallback(() => {
    if (store.currentTab !== OfferPageTabs.SETTINGS) {
      store.setCurrentTab(OfferPageTabs.SETTINGS);
    }
    if (store.selectedOption?.includes('H')) {
      store.setScrollTo('global.homeEffectiveDate');
    } else if (store.selectedOption?.includes('C')) {
      store.setScrollTo('global.condoEffectiveDate');
    } else if (store.selectedOption?.includes('A')) {
      store.setScrollTo('global.autoEffectiveDate');
    } else if (store.selectedOption?.includes('R')) {
      store.setScrollTo('global.rentersEffectiveDate');
    }

    const today = new Date();
    const threeDaysFromToday = addDays(today, 3);
    const eightDaysFromToday = addDays(today, 8);

    toast.notify({
      type: 'success',
      message: `Set the offer effective date(s) to ${format(threeDaysFromToday, 'MM/dd/yyyy')} or later to qualify for the Advance Quote Discount. Max discount applies for effective dates ${format(eightDaysFromToday, 'MM/dd/yyyy')} or later.`
    });
  }, [store, toast]);

  return <Discount {...discount} onAdd={onAdd} />;
};

export default observer(FutureEffectiveAdvancedQuote);
